import CoinyLogo, {ShadowCoinyLogo} from 'util/svg/logo/CoinyLogo';
import {useContext} from 'react';
import {UserContext} from 'components/user/UserContext';

export const coinyPresets = {
    colorful: {
        outerCircleC: '#266F2D',
        innerCircleC: '#266F2D',
        largeMuscleC: '#266F2D',
        innerMuscleC: '#266F2D',
        upperMuscleC: '#266F2D',
        coin1c: '#266F2D',
        coin2c: '#266F2D',
        coin3c: '#266F2D',
        coin4c: '#266F2D',
        coin5c: '#266F2D'
    },
    gold: {
        width: '659',
        height: '470',
        outerCircleC: 'gold',
        innerCircleC: 'orange',
        largeMuscleC: 'darkgoldenrod',
        innerMuscleC: 'yellow',
        upperMuscleC: 'gold',
        coin1c: 'gold',
        coin2c: 'gold',
        coin3c: 'gold',
        coin4c: 'gold',
        coin5c: 'gold'
    }
};


const CoinyLogoMonocolor = ({size = 659, color = 'black'}) => {
    const {isCashTenant} = useContext(UserContext);

    return <CoinyLogo
        width={size}
        height={(size * 470) / 659}
        outerCircleC={color}
        innerCircleC={color}
        largeMuscleC={color}
        innerMuscleC={color}
        upperMuscleC={color}
        coin1c={color}
        coin2c={color}
        coin3c={color}
        coin4c={color}
        coin5c={color}
        isCashTenant={isCashTenant}
    />;
};


export const CoinyLogoMonocolorShadowed = ({size = 659, color = 'black', showLetters = true, detailColor = color}) => {
    const {isCashTenant} = useContext(UserContext);

    return <ShadowCoinyLogo
        width={size}
        height={(size * 470) / 659}
        outerCircleC={color}
        innerCircleC={color}
        largeMuscleC={color}
        innerMuscleC={detailColor}
        upperMuscleC={color}
        coin1c={color}
        coin2c={color}
        coin3c={color}
        coin4c={color}
        coin5c={color}
        isCashTenant={isCashTenant}
        showLetters={showLetters}
    />;
};

export default CoinyLogoMonocolor;